/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * UpSmith Dev API
 * OpenAPI spec version: 1.0.0
 */

export type ConversationMessageDirection =
  (typeof ConversationMessageDirection)[keyof typeof ConversationMessageDirection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConversationMessageDirection = {
  inbound: "inbound",
  outbound: "outbound",
} as const;
